import {Component, OnInit} from '@angular/core';
import {MenuController, NavController} from 'ionic-angular';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../services/AuthService";
import {JWTAuthRequest} from "../../model/Credential";
import {Storage} from "@ionic/storage";
import {HomePage} from "../home/home";
import {MenuItemsProvider} from "../../providers/menu-items/menu-items";
import {AgencyConfigData} from "../../model/Agency";
import {apiconfig, ApplicationConfig, getAppConfiguration} from "../../app/api.config";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {AgencyConfigService} from "../../services/AgencyConfigService";
import {Locupa2Service} from "../../services/Locupa2Service";
import {Title} from "@angular/platform-browser";
import {e} from "@angular/core/src/render3";

/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage implements OnInit {

  appConfig: ApplicationConfig = getAppConfiguration();
  agency: AgencyConfigData = this.agencyConfigService.getAgencyConfigData();
  apiConfig: any = apiconfig;

  credential: JWTAuthRequest;
  authForm: FormGroup;
  errorMessage: string;

  private uiShowInstall: boolean;
  private deferredPrompt: any;
  private needUpdate: boolean;

  locupa2tokenUrl: string = this.locupa2Service.getLocupa2TokenUrl();

  constructor(
    private titleService: Title,
    private navCtrl: NavController,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private menu: MenuController,
    private menuItemsProvider: MenuItemsProvider,
    private httpClient: HttpClient,
    private agencyConfigService: AgencyConfigService,
    private storage: Storage,
    private locupa2Service: Locupa2Service) {


    window.addEventListener('beforeinstallprompt', (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      this.deferredPrompt = e;
      // Update UI notify the user they can install the PWA
      this.uiShowInstall = true;
      // Optionally, send analytics event that PWA install promo was shown.
      console.log(`'beforeinstallprompt' event was fired.`);
    });

  }


  ngOnInit(): void {

    // -- failsafe configuration check
    // we want to override configuration, to prevent from mistakes
    // quick solution to prevent from PROD being linked to Staging by bad-luck
    if (this.agency.platformType === 'prod') {
      this.apiConfig.API_URL = this.apiConfig.PROD_API_URL;
    } else if (this.agency.platformType === 'staging') {
      this.apiConfig.API_URL = this.apiConfig.STAGING_API_URL;
    } else if (this.agency.platformType === 'dev') {
      this.apiConfig.API_URL = this.apiConfig.DEV_API_URL;
    }

    this.titleService.setTitle(this.agency.appName);
    this.initForm();
  }

  ionViewDidLoad() {
    this.httpClient.get(apiconfig.CHECK_VERSION).toPromise().then((a: { version: string }) => {
        if (this.appConfig.build != a.version) {
          this.needUpdate = true;
        }
      }
    ).catch(a => {
      console.log("could not check version :(")
    });
  }


  /**
   * init Form, setup constraints.
   * could be a good place to handle an auto-login-token from loga
   * @private
   */
  private initForm() {
    this.authForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      rememberMe: [false, false]
    });
  }

  onSubmitForm() {
    this.credential = new JWTAuthRequest();
    this.credential.username = this.authForm.get('email').value;
    this.credential.password = this.authForm.get('password').value;

    this.authService.signInUser(this.credential)
      .then(
        (customerUser) => {
          if (customerUser) {

            // we need to build the main menu now that we now the user.
            // it can't be done before, as it might depend on the configuration of the user, or it's language
            // this should probably better done in a postLogin service
            this.menuItemsProvider.buildPages(customerUser);

            // show main page, we suppose it's hard-coded
            this.navCtrl.setRoot(HomePage);

            // connection ok , je peux montrer le menu
            this.menu.enable(true);
          }
        }
      ).catch(errorResp => {

      if (errorResp instanceof HttpErrorResponse) {
        var status = errorResp.status;
        var message = "Erreur d'identification";

        if (errorResp.error && typeof errorResp.error === 'object') {
          if (errorResp.error.msg) {
            message += ':  ' + errorResp.error.msg + '';
          } else if (errorResp.message) {
            message += ': ' + errorResp.message;
          }
        } else if (typeof errorResp === 'string') {
          message += ': ' + errorResp;
        } else if (errorResp.message) {
          message += ': ' + errorResp.message;
        }

        this.errorMessage = message;
      } else
        this.errorMessage = errorResp;
    });

  }

  /**
   * Pas de menu sur la page de login
   */
  ionViewWillEnter() {
    this.menu.enable(false);
  }


  onInstallClick() {
    this.uiShowInstall = false;
    // Show the install prompt
    this.deferredPrompt.prompt();
    // Wait for the user to respond to the prompt
    const {outcome} = this.deferredPrompt.userChoice;
    // Optionally, send analytics event with outcome of user choice
    console.log(`User response to the install prompt: ${outcome}`);
    // We've used the prompt, and can't use it again, throw it away
    this.deferredPrompt = null;
  }

  reloadMe() {
    console.log('reload me...')
    window.location.reload(true);
  }

  public resetLocupa2Token() {
    let data = {token: null, reset: true};

    setTimeout(() => {
      let iframeEl = document.getElementById("locupa2iFrame");
      console.log("Sending to Locupa iFrame the Token")
      if (iframeEl) {
        // @ts-ignore
        iframeEl.contentWindow.postMessage(JSON.stringify(data), this.locupa2Service.getLocupa2Url());
      } else {
        console.log('cannot find locupa2iFrame');
      }
    }, 1500);

  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts